import style from './ModalSelectSample.module.css';

import { address_server_short } from 'config';
import { PUBLIC_ASSETS } from 'config';
import Barcode from 'react-barcode';
import { useContext, useRef, useState } from 'react';
import { getTypeSampleSourcesList } from 'services/typeSampleSource.services';
import AddSampleSourceModal from 'components/WorkRight/WorkRightSamplesDir/SampleSources/forms/AddSampleSourceModal';
import { SampleSourceStore } from 'store/context/SampleSourceStore';

import UserFields from './UserFields';

const ExpandSample = ({ row }) => {
  const barcodesRef = useRef(null);

  const { setSampleSourceId } = useContext(SampleSourceStore);

  const [sampleSourceModal, setSampleSourceModal] = useState(false);
  const [typesSampleSource, setTypesSampleSource] = useState([]);

  const showSampleSourceModal = async (id) => {
    await setSampleSourceId(id);
    const { result } = await getTypeSampleSourcesList();
    setTypesSampleSource(result.data);
    setSampleSourceModal(true);
  };

  return (
    <div
      style={{
        display: 'flex',
        gap: '1rem',
        padding: '0.25rem',
      }}
    >
      <div
        style={{
          flex: '1',
        }}
      >
        <div className={style.separatingRow}>Описание образца</div>
        <div className={style.block1}>
          <div className={style.block1_text}>ID образца: {row?.id_general}</div>
        </div>
        <div className={style.block2}>
          <div className={style.icon}>
            {row.type?.icon && (
              <img
                className={style.iconType}
                src={`${address_server_short}${PUBLIC_ASSETS}${row.type?.icon}`}
              />
            )}
          </div>
          <div className={style.number}>
            {row?.name == null || row?.name == 'null' || row?.name == undefined ? '' : row?.name}
          </div>
        </div>
        <div>
          <div className={style.info_text}>Тип образца: {row.type?.name ?? ''}</div>
          <div className={style.info_text}>Расположение: {row.locations.path}</div>
          <div className={style.info_text}>Штатив: {row?.pack_name ?? ''}</div>
          <div className={style.info_text}>Позиция: {row.position}</div>
          <div className={style.block_barcode} ref={barcodesRef}>
            {row?.barcodes?.map((barcode) => (
              <div key={barcode.id}>
                <div className={style.block_barcode_text}>{barcode.value}</div>
                <Barcode
                  displayValue={false}
                  value={barcode.value}
                  height={30}
                  background={'#DCE6E9'}
                />
              </div>
            ))}
          </div>
          <div className={style.info2_text}>
            Количество образца: {row?.volume.amount} {row?.volume.unit_name}
          </div>
          {row?.aliquot_info && (
            <>
              <div className={style.info2_text}>Количество аликвот: {row?.aliquot_info?.total}</div>
              <div className={style.info2_text}>
                Общее количество образца: {row?.aliquot_info?.volume.amount}{' '}
                {row?.aliquot_info?.volume.unit_name}
              </div>
            </>
          )}

          <div style={{ margin: '25px 0' }} className={style.info2_text}>
            Исходный образец:{' '}
            <p
              style={{
                display: 'inline-block',
              }}
            >
              ID {row?.id_parent == null ? row?.id_general : row?.id_parent}
            </p>
          </div>

          <div className={style.info3}>
            <div className={style.info3_text}>Дата забора: {row?.created_at}</div>
            <div className={style.info3_text}>Изменен: {row?.updated_at}</div>
            <div className={style.info3_text}>
              Срок годности: {row?.expire_date ? row?.expire_date : 'Не указано'}
            </div>
          </div>

          {/* <button className={style.history} onClick={openHistory}>
            История изменений
          </button> */}
          <div style={{ margin: '25px 0' }} className={style.info2_text}>
            Описание: {row?.description}
          </div>
          <div style={{ margin: '25px 0' }} className={style.info2_text}>
            Разморозок осталось:{' '}
            {row?.defreeze != null && row?.defreeze != undefined ? row?.defreeze : 'Не указано'}
          </div>
          <div style={{ margin: '25px 0' }} className={style.info2_text}>
            Разморозок выполнено:{' '}
            {row?.defreeze_done != null && row?.defreeze_done != undefined
              ? row?.defreeze_done
              : '0'}
          </div>
          <div style={{ margin: '25px 0' }} className={style.info2_text}>
            Источник:{' '}
            {row?.sample_source != null && row?.sample_source != undefined ? (
              <p
                style={{
                  display: 'inline-block',
                  cursor: 'pointer',
                  textDecoration: 'underline',
                  color: 'blue',
                }}
                onClick={() => showSampleSourceModal(row?.sample_source?.id)}
              >
                {row?.sample_source?.name}
              </p>
            ) : (
              'Не указано'
            )}
          </div>
        </div>
      </div>
      <div
        style={{
          flex: '1',
        }}
      >
        <div className={style.separatingRow}>Пользовательские поля</div>
        <div>
          <div className={style.userFieldContainer}>
            <div className={style.userFieldContainer}>
              {row?.user_fields &&
                row?.user_fields?.map((val, index) => {
                  return <UserFields key={index} val={val} />;
                })}
            </div>
          </div>
        </div>
      </div>

      {sampleSourceModal && (
        <AddSampleSourceModal
          setModalOpened={setSampleSourceModal}
          typesSampleSource={typesSampleSource}
          disabled={true}
        />
      )}
    </div>
  );
};

export default ExpandSample;
